import { Outlet, useParams } from "react-router-dom";
import { skipToken } from "@reduxjs/toolkit/query";
import QueryWrapper from "common/components/QueryWrapper";
import { PlayLayout } from "common/layouts/PlayLayout";
import { useGetBingoGameQuery } from "bingo/api/bingo-game.api";
import {
  DEFAULT_PSG_BACKGROUND_MOBILE,
  DEFAULT_WHITE_COLOR,
} from "../../_graphic_design";

export function BingoGamePlayThemeWrapper() {
  const { bingoGameId } = useParams();
  const getGameQuery = useGetBingoGameQuery(bingoGameId || skipToken);

  const defaultGameTheme = {
    colors: {
      //background: "#131527",
      text: DEFAULT_WHITE_COLOR,
    },
    images: {
      playBackground: DEFAULT_PSG_BACKGROUND_MOBILE,
    },
  };

  return (
    <QueryWrapper query={getGameQuery}>
      {(bingoGame) => {
        const gameTheme = {
          colors: {
            //background: defaultGameTheme.colors.background,
            text:
              bingoGame.bingoTemplateSnapshot?.generalSettings?.textColor ||
              defaultGameTheme.colors.text,
          },
          images: {
            playBackground:
              bingoGame.bingoTemplateSnapshot?.images?.mobileBackground ||
              defaultGameTheme.images.playBackground,
          },
        };

        return (
          <PlayLayout theme={gameTheme}>
            <Outlet />
          </PlayLayout>
        );
      }}
    </QueryWrapper>
  );
}
